// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2OBg_","title":"Header_title__1EI9x","left":"Header_left__v2Mid","clinicName":"Header_clinicName__2bBkc"};